import React, { lazy, Suspense } from 'react';
import cx from 'classnames';
import * as componentStyling from '../styling';

const COMPONENTS = {
	LINEAR: lazy(() => import(
		/* webpackChunkName: "linear-progress" */
		'./linear'
	)),
	LINEAR_RHOMBUS: lazy(() => import(
		/* webpackChunkName: "linear-rhombus-progress" */
		'./linear/rhombus'
	)),
	CIRCULAR: lazy(() => import(
		/* webpackChunkName: "circular-progress" */
		'./circular'
	)),
	CIRCULAR_ROUND_DOTTED: lazy(() => import(
		/* webpackChunkName: "circular-round-dotted-progress" */
		'./circular/round-dotted'
	)),
	DEFAULT: lazy(() => import(
		/* webpackChunkName: "circular-progress" */
		'./circular'
	))
};

const Progress = React.memo(({ variant, ...props }) => {
	const Component = COMPONENTS[variant] || COMPONENTS['DEFAULT'];

	return (
		<Suspense fallback="...">
			<Component {...props} className={cx(componentStyling.Control)} />
		</Suspense>
	);
});

export default Progress;